import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62b3d5b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, null, -1))

import { onMounted, ref } from 'vue';
import TemplateRequest from '../../data/TemplateRequest';


export default /*#__PURE__*/_defineComponent({
  __name: 'Template-002',
  props: {
    view_key: {}
  },
  setup(__props: any) {

const props = __props;

const img_src = ref('');

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var cardData: any = TemplateRequest.getViewDataByKey(props.view_key);
  img_src.value = cardData.img_src;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "mainImg",
        src: img_src.value
      }, null, 8, _hoisted_3),
      _hoisted_4
    ])
  ]))
}
}

})